import { render, staticRenderFns } from "./GroupCard.vue?vue&type=template&id=7c84f447&"
import script from "./GroupCard.controller.js?vue&type=script&lang=js&"
export * from "./GroupCard.controller.js?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./GroupCard.styles.scss?vue&type=style&index=0&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "8854b4cc"
  
)

export default component.exports